import React, { useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography
} from "@mui/material";
import { useKivunovaTranslation } from "@kivunova/kivufrontendcommon";
import AppButton from "../../common/AppButton";

export interface ArchiveEntityDialogProps {
  open: boolean;
  entityLabel: string;
  loading?: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void | Promise<void>;
}

/** P0.8 — confirm archive with optional reason (optimistic version handled by caller). */
const ArchiveEntityDialog: React.FC<ArchiveEntityDialogProps> = ({
  open,
  entityLabel,
  loading = false,
  onClose,
  onConfirm
}) => {
  const { t } = useKivunovaTranslation();
  const [reason, setReason] = useState("");

  const handleClose = () => {
    setReason("");
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>
        {t("archive-entity-title", "Archive {{entity}}", {
          entity: entityLabel
        })}
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {t(
            "archive-entity-warning",
            "Archived records stay in history but cannot be used for new billing or placement."
          )}
        </Typography>
        <TextField
          fullWidth
          multiline
          minRows={2}
          label={t("archive-reason", "Reason (optional)")}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <AppButton variant="text" onClick={handleClose} disabled={loading}>
          {t("cancel", "Cancel")}
        </AppButton>
        <AppButton
          variant="danger"
          disabled={loading}
          onClick={async () => {
            await onConfirm(reason.trim());
            setReason("");
          }}
        >
          {t("archive", "Archive")}
        </AppButton>
      </DialogActions>
    </Dialog>
  );
};

export default ArchiveEntityDialog;
